export default {
  screens: [
    {
      type: 'intro',
      title: '情感珠寶',
      content:
        '幸福與生活是CHAUMET的創作核心，我們用它來見證人生中的每個璀璨時刻。',
      idYt: '9RbWHsnfvK0',
      videoCover: 'world/sentimental/video.jpg',
      desktop: {
        cover: 'world/sentimental/cover-1.jpg'
      },
      mobile: {
        cover: 'world/sentimental/mobile-cover-1.jpg',
        contentStyle: { width: '100%' },
        coverStyle: {
          width: '100%',
          height: 'auto',
          bottom: '-27%',
          right: '0',
          left: '0',
          position: 'absolute'
        }
      }
    },
    {
      type: 'perspective',
      leftImg: 'world/sentimental/perspectiveLeft.jpg',
      middleImg: 'world/sentimental/perspectiveMiddle.jpg',
      rightImg: 'world/sentimental/perspectiveRight.jpg',
      content:
        '如熱戀時的緊密相連，又如徜徉在愛情裡的自由無拘，「緣繫·一生」系列珠寶重新演繹珠寶靈動與迷人的魅力。',
      cover: 'world/sentimental/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'world/sentimental/shadowMiddle.jpg',
        leftImg: 'world/sentimental/shadowLeft.jpg',
        cover: 'world/sentimental/cover-3.jpg'
      },
      mobile: {
        middleImg: 'world/sentimental/shadowMiddle.jpg',
        leftImg: 'world/sentimental/shadowLeft.jpg',
        rightImg: 'world/sentimental/perspectiveRight.jpg',
        cover: 'world/sentimental/mobile-cover-1.jpg',
        coverStyle: {
          width: '100%',
          height: 'auto',
          bottom: '0',
          left: '-18%',
          position: 'absolute'
        }
      },
      content:
        '「緣繫·一生」是CHAUMET自 1780 年創立以來最能承載傳統情感珠寶的經典系列。CHAUMET以其表達緣分、傳遞情感，也是友誼、愛情和諾言的象徵。 '
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cht/worlds/sentimental.js